module.exports = __webpack_public_path__ + "static/img/13004B_3_R_20200729_LC.e5ea5e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13004B_3_R_20200729_LC.png
// module id = Gysw
// module chunks = 0